if (!customElements.get('tb-rating-label')) {
  customElements.define('tb-rating-label', class extends HTMLElement {
    connectedCallback() {
      this.observer?.disconnect();
      const update = () => {
        const label = this.dataset.label;
        if (!label) return;
        this.querySelectorAll('.jdgm-prev-badge__text').forEach(node => {
          if (node.textContent !== label) node.textContent = label;
        });
      };
      this.observer = new MutationObserver(update);
      this.observer.observe(this, {childList:true, subtree:true, characterData:true});
      update();
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
}
